import { render } from 'react-dom';
import '@atlaskit/css-reset/dist/bundle.css';
import { App } from './App';

render(<App />, document.getElementById('root'));
